import { VALIDATE_USER_BACKEND } from '@constants/urlConstants';
import PageLoader from '@ui_components/PageLoader';
import { getCookie } from '@utility/cookies';
import { getEnvConstantsValue, getEnvironmentVariablesValue } from '@utility/environmentVariables';
import getTokenDetails from '@utility/getTokenDetails';
import { getSSOUserOrganizations} from '@utility/validateSSOUser';
import { GetServerSideProps } from 'next';
import dynamic from 'next/dynamic';

const MainContainer = dynamic(() => import('@containers/MainContainer'), { loading: () => <PageLoader /> });

type HomeComponentProps = {
  tokenDetails: TokenDetailsProps,
  defaultPage: string,
}

const HomePage = ({ tokenDetails, defaultPage}: HomeComponentProps) => {
  return (
    <MainContainer defaultPage={defaultPage} tokenDetails={tokenDetails} organizationName={getEnvironmentVariablesValue("DEFAULT_ORGANIZATION")}/>
  );
}

export const getServerSideProps: GetServerSideProps = async ({ req, query }) => {
  const defaultProductPageValue = getEnvConstantsValue("DEFAULT_PRODUCT_PAGE");
  const defaultProductPage = Boolean(defaultProductPageValue) && defaultProductPageValue !== "false";
  const signupIsDisabled = getEnvironmentVariablesValue("DISABLE_SIGNUP") === "true"
  const cookies = (req.headers.cookie || "")
  const accessToken = String(query?.token || getCookie("access_token", cookies) || "")
  const noAuthToken = String(getCookie("token", cookies) || "")
  const tokenDetails = await getTokenDetails(accessToken,defaultProductPage,noAuthToken)
  const ssoOrganizations = query?.data? await getSSOUserOrganizations(String(query?.data) , VALIDATE_USER_BACKEND):{ organizations: [], ssoToken: "" }
  const toShowSelectOrganizationPage = ssoOrganizations.organizations.length > 1;

  const getDefaultPage = () => {
    if (toShowSelectOrganizationPage) return "ssoauth";
    if (defaultProductPage) return "noauth";
    if (signupIsDisabled) return "login";
    return "signup";
  };

  return {
    props: {
      tokenDetails: tokenDetails,
      defaultPage: getDefaultPage(),
    },
  };
};

export default HomePage
